import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { fg } from '@confluence/feature-gating';
import { HOME } from '@confluence/named-routes/entry-points/routes.ts';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { Redirection } from '@confluence/route-manager/entry-points/Redirection.ts';
import { AISearchPage } from '@confluence/rovo-ai-search/entry-points/AISearchPage.tsx';

export const AISearchRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(routeMatch: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
			};
			pageState: {
				aiSearchQuery: string | string[];
			};
		};
		MainLayout: {
			navView: string;
			aiSearchQuery: string | string[];
		};
	};
} = (): React.JSX.Element => {
	if (!fg('rovo_ai_mode_enabled')) {
		return <Redirection name={HOME.name} />;
	}

	return <AISearchPage />;
};

AISearchRoute.NAVIGATION_PARAMS = (
	routeMatch: RouteMatch,
): {
	Screen: {
		screenEvent: {
			name: string;
		};
		pageState: {
			aiSearchQuery: string | string[];
		};
	};
	MainLayout: {
		navView: string;
		aiSearchQuery: string | string[];
	};
} => {
	const aiSearchQuery = routeMatch?.query?.aiSearchQuery ?? '';
	return {
		Screen: {
			screenEvent: { name: 'aiSearchPageScreen' },
			pageState: {
				aiSearchQuery,
			},
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
			aiSearchQuery,
		},
	};
};
